import React from "react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { CheckCircle, ArrowRight } from "lucide-react";

const HowItWorksSection = ({ data }) => {
  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <Badge className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full mb-4">
            Program Structure
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {data.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {data.subtitle}
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-amber-400 to-orange-500 rounded-full"></div>

          {data.steps.map((step, index) => (
            <div key={index} className={`relative mb-12 ${index % 2 === 0 ? 'md:pr-1/2' : 'md:pl-1/2 md:text-right'}`}>
              {/* Timeline Node */}
              <div className="hidden md:block absolute top-8 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full border-4 border-white shadow-lg z-10"></div>
              
              {/* Arrow */}
              <div className={`hidden md:block absolute top-10 ${index % 2 === 0 ? 'right-8' : 'left-8'}`}>
                <ArrowRight className={`w-6 h-6 text-amber-500 ${index % 2 !== 0 ? 'rotate-180' : ''}`} />
              </div>

              <Card className={`max-w-lg ${index % 2 === 0 ? 'md:ml-auto md:mr-16' : 'md:mr-auto md:ml-16'} hover:shadow-xl transition-all duration-300 border-0 bg-white shadow-lg`}>
                <CardContent className="p-8">
                  <div className="flex items-center gap-4 mb-4">
                    <Badge className="bg-gradient-to-r from-amber-500 to-orange-600 text-white px-3 py-1 text-sm font-semibold">
                      {step.phase}
                    </Badge>
                    <span className="text-sm text-gray-500 font-medium">{step.duration}</span>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{step.description}</p>
                  
                  <div className="space-y-2">
                    {step.activities.map((activity, actIndex) => (
                      <div key={actIndex} className="flex items-center gap-3">
                        <CheckCircle className="w-5 h-5 text-amber-500 flex-shrink-0" />
                        <span className="text-gray-700">{activity}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;